<section *removeIfUnauthorized="hasAdmin">
  <h2 class="h4">Import Users</h2>
  <ng-container *ngIf="userImportTemplate$ | async as templateLink">
    <button class="btn btn-link px-0" (click)="onClickDownload(templateLink)"><i aria-hidden="true" class="fas fa-file-download"></i> Download the template to bulk upload user into the system.</button>
    <p class="my-2 fst-italic"><small>Note: Last updated on {{ templateLink.ModifiedOn ? (templateLink.ModifiedOn | utcToLocal:'MM/dd/yyyy  HH:mm') : (templateLink.CreatedOn | utcToLocal:'MM/dd/yyyy  HH:mm')}}</small></p>
    <a aria-hidden="true" class="d-none" [download]="templateLink.FileName" #downloadTemplateLink></a>
  </ng-container>
  <div *ngIf="fileTransferSucceeded" class="alert alert-success alert-dismissible fade show" role="alert">
    <i class="fas fa-check-circle" aria-hidden="true"></i><strong class="mx-2">{{importStatusMessage}}</strong>
    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
  </div>
  <div class="my-3">
    <p-fileUpload #fileUpload id="BulkUserUpload" name="myfile[]" url="{{apiRoot}}/api/admin/BulkUserUpload" (onUpload)="onUploadHandler($event)" (onBeforeUpload)="onSendHandler()" [headers]="customHeaders"> </p-fileUpload>
    <button type="button" (click)="refreshStatus()" class="btn btn-success btn-sm my-3">Refresh User Import Status</button>
  </div>
  <div class="my-5">
    <p-table [hidden]="!importedUserResults || importedUserResults?.length == 0" [value]="importedUserResults" [columns]="cols" [paginator]="true" [alwaysShowPaginator]="false" [rows]="rows">
      <ng-template pTemplate="header" let-columns>
        <tr><th colspan="8" scope="colgroup" class="bg-warning">Failed Import Items</th></tr>
        <tr>
          <th *ngFor="let col of columns" scope="col">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-import let-columns="columns">
        <tr>
          <th scope="row">{{import.FirstName}}</th>
          <ng-container *ngFor="let col of columns;let i=index">
            <td *ngIf="i > 0" [ngSwitch]="col.field">
              <span *ngSwitchCase="'ItemUploadDateTime'">{{ import[col.field] | utcToLocal:'MM/dd/yyyy  HH:mm'}}</span>
              <ng-container *ngSwitchCase="'Status'">
                <span aria-hidden="true" pTooltip="{{import.Errors }}">{{ import.Status}}</span><span class="visually-hidden">{{import.Status}} ({{import.Errors}})</span>
              </ng-container>
              <span *ngSwitchDefault>{{import[col.field]}}</span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <th scope="row" [attr.colspan]="columns.length">
            No failed import items found.
          </th>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>
